module.exports = __webpack_public_path__ + "img/home-hero-woman-computer-800.7c51442.jpg";